import React, { Component } from "react";

export default class MobileDevImg extends Component {
  render() {
    const theme = this.props.theme;
    const primary = theme.imageHighlight || "#0E6BA8";
    const accent = theme.headerColor || "#0E6BA877";
    const surface = theme.body || "#ffffff";
    const ink = theme.text || "#001C55";

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="auto"
        viewBox="0 0 500 400"
        fill="none"
        aria-label="iPhone with apps and Swift logo"
      >
        <defs>
          <linearGradient id="mobile-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={primary} stopOpacity="0.15" />
            <stop offset="100%" stopColor={primary} stopOpacity="0.02" />
          </linearGradient>
        </defs>

        <ellipse cx="250" cy="370" rx="170" ry="14" fill={accent} opacity="0.4" />

        {/* iPad in background */}
        <rect x="320" y="80" width="140" height="200" rx="14" fill={primary} opacity="0.2" />
        <rect x="332" y="92" width="116" height="176" rx="6" fill={surface} />
        <rect x="344" y="108" width="92" height="6" rx="3" fill={primary} opacity="0.45" />
        <rect x="344" y="124" width="60" height="6" rx="3" fill={primary} opacity="0.3" />
        <rect x="344" y="148" width="92" height="40" rx="6" fill={primary} opacity="0.25" />
        <rect x="344" y="200" width="44" height="40" rx="6" fill={primary} opacity="0.18" />
        <rect x="392" y="200" width="44" height="40" rx="6" fill={primary} opacity="0.18" />

        {/* iPhone */}
        <rect x="60" y="60" width="220" height="320" rx="38" fill={ink} />
        <rect x="70" y="70" width="200" height="300" rx="30" fill="url(#mobile-grad)" />
        <rect x="70" y="70" width="200" height="300" rx="30" fill={surface} opacity="0.7" />

        {/* notch */}
        <rect x="155" y="78" width="30" height="6" rx="3" fill={ink} />

        {/* status bar */}
        <rect x="92" y="100" width="36" height="6" rx="3" fill={primary} opacity="0.6" />
        <rect x="220" y="100" width="30" height="6" rx="3" fill={primary} opacity="0.6" />

        {/* hero card */}
        <rect x="92" y="124" width="156" height="60" rx="10" fill={primary} />
        <rect x="104" y="138" width="80" height="6" rx="3" fill={surface} opacity="0.9" />
        <rect x="104" y="152" width="60" height="5" rx="2" fill={surface} opacity="0.7" />
        <rect x="104" y="164" width="46" height="5" rx="2" fill={surface} opacity="0.7" />

        {/* app grid */}
        {[0, 1, 2].map((row) =>
          [0, 1, 2].map((col) => (
            <rect
              key={`${row}-${col}`}
              x={92 + col * 56}
              y={200 + row * 50}
              width="44"
              height="44"
              rx="10"
              fill={primary}
              opacity={0.55 - row * 0.12 - col * 0.05}
            />
          ))
        )}

        {/* home indicator */}
        <rect x="138" y="354" width="64" height="4" rx="2" fill={ink} opacity="0.4" />

        {/* Swift bird emblem */}
        <g transform="translate(360,300)">
          <circle r="40" fill={primary} />
          <path
            d="M-18,-8 C-10,-2 -2,4 8,8 C14,10 18,8 20,4 C16,8 8,10 0,8 C-8,6 -14,2 -18,-2 Z M-20,12 C-12,18 0,22 12,20 C16,16 18,10 16,4 C14,10 6,12 -2,10 C-10,8 -16,4 -20,0 Z"
            fill={surface}
          />
        </g>
      </svg>
    );
  }
}
